<template>
  <validation-observer ref="simpleRules">

    <p class="mt-2">
      <strong class="text-primary">{{ $t('Log') }}</strong>
    </p>

    <b-row class="align-items-end">
      <b-col md="2">
        <b-form-group
          :label="$t('Start Date')"
          label-for="start-date"
          class="mb-0"
        >
          <flat-pickr
            v-model="startDate"
            :placeholder="$t('From...')"
            class="form-control"
            :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group
          :label="$t('End Date')"
          label-for="end-date"
          class="mb-0"
        >
          <flat-pickr
            v-model="endDate"
            :placeholder="$t('To...')"
            class="form-control"
            :config="{ enableTime: false, dateFormat: 'Y-m-d' }"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group
          :label="$t('Email')"
          label-for="email"
          class="mb-0"
        >
          <b-form-input
            v-model="email"
            :placeholder="$t('Email...')"
            @input="autoTitleFlag = false"
          />
        </b-form-group>
      </b-col>
      <b-col md="5">
        <b-button
          variant="primary"
          class="mr-1"
          @click="downloadLog"
        >
          {{ $t('Download Log') }}
        </b-button>
        <!-- Todo: Log Report -->
        <b-button v-if="2===3"
          variant="primary"
          @click="downloadLogReport"
        >
          {{ $t('Download Log Report') }}
        </b-button>
      </b-col>
    </b-row>

    <p class="mt-2">
      <strong class="text-primary">{{ $t('General Settings') }}</strong>
    </p>

    <b-form
      v-if="item"
      autocomplete="off"
    >
      <!-- Maintenance Mode -->
      <b-form-group
        label="Maintenance Mode?"
        label-for="maintenanceMode"
      >
        <b-form-checkbox
          id="maintenanceMode"
          v-model="item.MaintenanceMode"
          class="mt-1"
          name="maintenanceMode"
          switch
        >
          <span v-if="item.MaintenanceMode">{{ $t('Yes') }}</span>
          <span v-if="!item.MaintenanceMode">{{ $t('No') }}</span>
        </b-form-checkbox>
      </b-form-group>

      <!-- Two Factor Auth -->
      <b-form-group
        label="Two Factor Auth?"
        label-for="twoFactorAuth"
      >
        <b-form-checkbox
          id="twoFactorAuth"
          v-model="item.TwoFactorAuth"
          class="mt-1"
          name="twoFactorAuth"
          switch
        >
          <span v-if="item.TwoFactorAuth">{{ $t('Yes') }}</span>
          <span v-if="!item.TwoFactorAuth">{{ $t('No') }}</span>
        </b-form-checkbox>
      </b-form-group>

      <b-row>
        <b-col md="6">

          <!-- Password Reset Url -->
          <b-form-group
            label="Password Reset Url"
            label-for="mc-PasswordResetUrl"
          >
            <validation-provider
              #default="{ errors }"
              name="Password Reset Url"
              rules="required"
            >
              <b-form-input
                v-model="item.PasswordResetUrl"
                :state="errors.length > 0 ? false : null"
                placeholder="Password Reset Url"
              />
              <small class="text-danger">
                {{ $t(errors[0]) }}
              </small>
            </validation-provider>
          </b-form-group>

          <!-- SSO Login Url -->
          <b-form-group
            label="SSO Login Url"
            label-for="mc-SsoLoginUrl"
          >
            <b-form-input
              v-model="item.SsoLoginUrl"
              placeholder="SSO Login Url"
            />
          </b-form-group>

          <!-- SSO Logout Url -->
          <b-form-group
            label="SSO Logout Url"
            label-for="mc-SsoLogoutUrl"
          >
            <b-form-input
              v-model="item.SsoLogoutUrl"
              placeholder="SSO Logout Url"
            />
          </b-form-group>

          <!-- Media Service -->
          <b-form-group
            label="Media Service"
            label-for="mc-mediaKey"
          >
            <b-form-input
              v-model="item.MediaKey"
              placeholder="Media Service"
            />
          </b-form-group>

          <!-- Hot Alert Service Ip Restrictions -->
          <b-form-group
            label="Hot Alert Service Ip Restrictions"
            label-for="mc-ipList"
          >
            <b-form-input
              v-model="item.IpList"
              placeholder="x.x.x.x, y.y.y.y, z.z.z.z"
            />
          </b-form-group>

        </b-col>
        <b-col md="6">
          <b-row>
            <b-col md="9">
              <!-- Mail Server -->
              <b-form-group
                label="Mail Server"
                label-for="mc-MailServer"
              >
                <b-form-input
                  v-model="item.MailServer"
                  placeholder="Mail Server Url"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <!-- Mail Server Port -->
              <b-form-group
                label="Port"
                label-for="mc-MailServerPort"
              >
                <b-form-input
                  v-model="item.MailServerPort"
                  placeholder="port"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Mail Server Email-->
          <b-form-group
            label="Email"
            label-for="mc-MailServerEmail"
          >
            <b-form-input
              v-model="item.MailServerEmail"
              placeholder="Mail From"
            />
          </b-form-group>

          <!-- Mail Server From-->
          <b-form-group
            label="From"
            label-for="mc-MailServerFromName"
          >
            <b-form-input
              v-model="item.MailServerFromName"
              placeholder="Display Name"
            />
          </b-form-group>

          <b-row>
            <b-col md="6">
              <!-- Mail Server Username-->
              <b-form-group
                label="User Name"
                label-for="mc-MailServerUsername"
              >
                <b-form-input
                  v-model="item.MailServerUsername"
                  autocomplete="off"
                  placeholder="Username"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Mail Server Password -->
              <b-form-group
                label="Password"
                label-for="mc-MailServerPass"
              >
                <b-form-input
                  v-model="item.MailServerPass"
                  type="password"
                  placeholder="password"
                  autocomplete="new-password"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6">
              <!-- Hide User Dropdown -->
              <b-form-group
                label="Profil Menusunu Gizle?"
                label-for="hideUserDropDown"
              >
                <b-form-checkbox
                  id="hideUserDropDown"
                  v-model="item.HideUserDropDown"
                  class="mt-1"
                  name="hideUserDropDown"
                  switch
                >
                  <span v-if="item.hideUserDropDown">{{ $t('Yes') }}</span>
                  <span v-if="!item.hideUserDropDown">{{ $t('No') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col md="6">
              <!-- Logo On Top -->
              <b-form-group
                v-if="show.logo"
                label="Logo on top?"
                label-for="logoOnTop"
              >
                <b-form-checkbox
                  id="logoOnTop"
                  v-model="item.LogoOnTop"
                  class="mt-1"
                  name="logoOnTop"
                  switch
                >
                  <span v-if="item.LogoOnTop">{{ $t('Yes') }}</span>
                  <span v-if="!item.LogoOnTop">{{ $t('No') }}</span>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <!-- AI -->
      <p class="mt-2">
        <strong class="text-primary">{{ $t('Client Description for AI') }}</strong>
      </p>
      <!-- Description for AI -->
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Description')"
            label-for="mc-description"
          >
            <b-form-textarea
              v-model="item.Description"
              :placeholder="$t('Description...')"
              rows="3"
              max-rows="6"
              max-length="500"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Instructions for AI -->
      <b-row>
        <b-col>
          <b-form-group
            :label="$t('Assistant Instructions')"
            label-for="mc-assistantInstructions"
          >
            <b-form-textarea
              v-model="item.AssistantInstructions"
              :placeholder="$t('Instructions...')"
              rows="10"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- AI Mode chat/summary-->
      <b-row>
        <b-col md="6">
          <b-form-group
            label="AI Mode (Summary / Chat)"
            label-for="aiMode"
          >
            <b-form-checkbox
              id="aiMode"
              v-model="item.AiModeChat"
              class="mt-1"
              name="aiModeChat"
              switch
            >
              <span v-if="item.AiModeChat">{{ $t('Chat') }}</span>
              <span v-if="!item.AiModeChat">{{ $t('Summary') }}</span>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        class="d-inline-block mr-1"
        @click="validationForm"
      >
        Save
      </b-button>

      <!-- Logo Image -->
      <hr>
      <p class="mt-2">
        <strong class="text-primary">{{ $t('Logo') }}</strong>
      </p>
      <div class="mb-2">
        <FormUploadImage
          :image-type="'logoImage'"
          @submit="show.logo = true"
          @deleted="show.logo = false"
        />
        <img
          v-if="show.logo"
          style="max-height:120px"
          :src="`${baseUrl()}/settings/download/logoImage`"
          onerror="this.style.display='none'"
          alt=""
        >
      </div>

      <!-- Background Image -->
      <hr>
      <p class="mt-2">
        <strong class="text-primary">{{ $t('Background Image') }}</strong>
      </p>
      <div class="mb-2">
        <FormUploadImage
          :image-type="'backgroundImage'"
          @submit="show.bg = true"
          @deleted="show.bg = false"
        />

        <img
          v-if="show.bg"
          style="max-height:240px"
          :src="`${baseUrl()}/settings/download/backgroundImage`"
          onerror="this.style.display='none'"
          alt=""
        >
      </div>

      <!-- Vacuum -->
       <template v-if="role === 'superadmin'">
        <hr>
        <p class="mt-2">
          <strong class="text-primary">{{ $t('Vacuum') }} - DO NOT CLICK!!!</strong>
        </p>
        <div class="mb-2">
          <b-button variant="primary" @click="startVacuum" :disabled="vacuumInProgress">
            {{ vacuumInProgress ? $t('Vacuum In Progress') : $t('Start Vacuum') }}
          </b-button>
        </div>
        <div v-if="vacuumData">
          <b-table :items="vacuumData">
            <b-table-column field="command" label="Command"></b-table-column>
            <b-table-column field="success" label="Success"></b-table-column>
            <b-table-column field="error" label="Error"></b-table-column>
            <b-table-column field="durationMs" label="Duration (ms)"></b-table-column>
          </b-table>
        </div>
       </template>
    </b-form>
  </validation-observer>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import flatPickr from 'vue-flatpickr-component'
import FormUploadImage from '@/layouts/components/forms/FormUploadImage.vue'
import dayjs from 'dayjs'

import {
  BFormGroup, BFormInput, BForm, BButton, BFormCheckbox, BRow, BCol,
  BFormTextarea, BTable, BTableColumn,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

import { baseUrl } from '@/libs/axios'
import { getUserData } from '@/auth/utils'

export default {
  components: {
    FormUploadImage,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BFormCheckbox,
    BFormTextarea,
    BRow,
    BCol,
    BTable,
    BTableColumn,
  },
  directives: {
    Ripple,
  },
  // mixins: [rootUrl],
  data() {
    return {
      show: {
        logo: true,
        bg: true,
      },
      item: null,
      required,
      baseUrl,
      startDate: dayjs().add(-1, 'months').format('YYYY-MM-DD'),
      endDate: dayjs().format('YYYY-MM-DD'),
      email: null,
      vacuumData: null,
      vacuumInProgress: false,
      role: null,
    }
  },
  created() {
    this.getSettings()
    this.role = getUserData().role
  },
  methods: {
    startVacuum() {
      this.vacuumInProgress = true
      useJwt.axiosIns.post('helper/vacuumdatatables')
        .then(response => {
          this.vacuumInProgress = false
          this.vacuumData = response.data
          if (response.data) {
            this.$swal({
              icon: 'success',
              title: 'Success!',
              text: 'Vacuum completed successfully.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          } else {
            this.$swal({
              icon: 'error',
              title: 'Error!',
              text: 'Failed to vacuum!',
              customClass: {
                confirmButton: 'btn btn-danger',
              },
            })
          }
        })
        .catch(e => {
          this.vacuumInProgress = false
          console.log(e)
        })
    },
    refreshImage(imageType) {
      this.$set(this.item, imageType, `/api/download?imageType=${imageType}`)
    },
    downloadLog() {
      if (!this.startDate || !this.endDate) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Please select start and end date!',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return
      }
      console.log('this.endDate - this.startDate', dayjs(this.endDate).diff(dayjs(this.startDate), 'years'))
      if (dayjs(this.endDate).diff(dayjs(this.startDate), 'years') > 1) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Maximum duration should be 1 year!',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return
      }
      useJwt.axiosIns.get('settings/GetLog', { params: { startDate: this.startDate, endDate: this.endDate, email: this.email } })
        .then(response => {
          if (response.data) {
            this.openFile(response, `logs_${new Date()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    downloadLogReport() {
      if (!this.startDate || !this.endDate) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Please select start and end date!',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return
      }
      console.log('this.endDate - this.startDate', dayjs(this.endDate).diff(dayjs(this.startDate), 'years'))
      if (dayjs(this.endDate).diff(dayjs(this.startDate), 'years') > 1) {
        this.$swal({
          icon: 'error',
          title: 'Error!',
          text: 'Maximum duration should be 1 year!',
          customClass: {
            confirmButton: 'btn btn-danger',
          },
        })
        return
      }
      useJwt.axiosIns.get('settings/GetLogReport', { params: { startDate: this.startDate, endDate: this.endDate, email: this.email } })
        .then(response => {
          if (response.data) {
            this.openFile(response, `log_reports_${new Date()}.csv`)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    openFile(response, filename) {
      const blob = new Blob([`\ufeff${response.data}`], {
        type: 'text/csv; charset=utf-8',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
      link.remove()
    },
    getSettings() {
      useJwt.axiosIns.get('settings').then(response => {
        this.item = response.data
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // clear legacy background image and logo image base64 values!
          delete this.item.BackgroundImage
          delete this.item.LogoImage
          const postObject = { settingsJson: JSON.stringify(this.item) }
          useJwt.axiosIns.post('settings', postObject)
            .then(response => {
              if (response.data === 'OK') {
                this.$swal({
                  icon: 'success',
                  title: 'Saved!',
                  text: 'Settings saved successfully.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              } else {
                this.$swal({
                  icon: 'error',
                  title: 'Error!',
                  text: 'Settings not saved!',
                  customClass: {
                    confirmButton: 'btn btn-danger',
                  },
                })
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      })
    },
  },
}
</script>
